document.addEventListener('DOMContentLoaded', function () {

    function initializeCheckboxHandler() {
        const toggleCheckbox = document.getElementById('shipping-product-toggle');
        if (toggleCheckbox) {

            toggleCheckbox.removeEventListener('change', handleCheckboxChange);
            toggleCheckbox.addEventListener('change', handleCheckboxChange);
            console.log("Checkbox handler initialized");
        } else {
            console.log("Shipping product toggle not found (cart is likely empty)");
        }
    }


    function handleCheckboxChange(e) {
        const productId = e.currentTarget.value;
        const isChecked = e.target.checked;
        console.log("Product ID:", productId);

        if (!productId) {
            console.error("Product ID is empty or invalid");
            return;
        }

        if (isChecked) {
            addToCart(productId);
        } else {
            removeFromCart(productId);
        }
    }


    checkPrioVersandInCart();


    initializeCheckboxHandler();


    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    if (cartDrawer.classList.contains('active')) {
                        console.log("Cart drawer opened (class active detected), reinitializing checkbox handler");
                        initializeCheckboxHandler();
                        checkPrioVersandInCart();
                    }
                }
            });
        });

        observer.observe(cartDrawer, { attributes: true });
    } else {
        console.error("Cart drawer element not found");
    }


    document.addEventListener('cart:updated', function () {
        console.log("Cart updated, reinitializing checkbox handler");
        initializeCheckboxHandler();
        checkPrioVersandInCart();
    });
});


function checkPrioVersandInCart() {
    const toggleCheckbox = document.getElementById('shipping-product-toggle');
    if (!toggleCheckbox) {
        console.log("Shipping product toggle not found for checking Prio Versand (cart is likely empty)");
        return;
    }

    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const prioVersandProduct = cart.items.find(item => item.product_title.includes('Prio Versand'));
            toggleCheckbox.checked = !!prioVersandProduct;
            console.log("Prio Versand in cart:", !!prioVersandProduct);
        })
        .catch(error => console.error('Error checking Prio Versand in cart:', error));
}

// Функция для добавления продукта в корзину
function addToCart(productId) {
    const cartElement = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    const formData = {
        'id': productId,
        'quantity': 1,
        'sections': cartElement.getSectionsToRender().map((section) => section.id)
    };

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
    })
        .then(response => {
            if (!response.ok) {
                return response.json().then(err => {
                    throw new Error(JSON.stringify(err));
                });
            }
            return response.json();
        })
        .then(data => {
            console.log("Product added:", data);
            updateCartTotal();
            checkPrioVersandInCart();
            cartElement.renderContents(data);
        })
        .catch(error => {
            console.error('Error adding product to cart:', error);
            const toggleCheckbox = document.getElementById('shipping-product-toggle');
            if (toggleCheckbox) toggleCheckbox.checked = false;
        });
}


function removeFromCart(productId) {
    const cartElement = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            if (productId) {
                const formData = {
                    'id': productId,
                    'quantity': 0,
                    'sections': cartElement.getSectionsToRender().map((section) => section.id)
                };

                console.log("Attempting to remove item with lineItem.id:", productId);

                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData),
                })
                    .then(response => {
                        if (!response.ok) {
                            return response.json().then(err => {
                                throw new Error(JSON.stringify(err));
                            });
                        }
                        return response.json();
                    })
                    .then(data => {
                        console.log("Product removed:", data);
                        updateCartTotal();
                        checkPrioVersandInCart();
                        cartElement.renderContents(data);
                    })
                    .catch(error => {
                        console.error('Error removing product from cart:', error);
                    });
            } else {
                console.log('Product not found in cart.');
            }
        })
        .catch(error => console.error('Error fetching cart:', error));
}


function updateCartTotal() {
    console.log('updateCartTotal')
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const totalPrice = cart.total_price / 100;
            const totalElement = document.querySelector('.totals__subtotal-value');
            if (totalElement) {
                totalElement.textContent = `${totalPrice.toFixed(2)}€`;
            } else {
                console.log("Total element (.totals__subtotal-value) not found (cart is likely empty)");
            }

            if (typeof getCartTotal === 'function') {
                getCartTotal();
            }
        })
        .catch(error => {
            console.error('Error fetching cart total:', error);
        });
}
